import styled from "styled-components";
// builders
import * as buttonDesignTypes from "../../../builders/buttonDesign.types";

export const ButtonStyles = styled.button`
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.body.b2.weight};
  font-size: ${({ theme }) => theme.typography.body.b2.size};
  line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
  letter-spacing: 0.1px;
  cursor: pointer;
  outline: none;
  border-radius: ${({ theme }) => theme.radius[8]};
  padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[12]};

  ${({ $buttonDesignType, theme }) => {
    switch ($buttonDesignType) {
      case buttonDesignTypes.PRIMARY:
        return `
        background: ${theme.colors.semantic.accent.default};
        color: ${theme.colors.semantic.accent.onAccent};
        border: 1px solid ${theme.colors.semantic.accent.default};
      `;

      case buttonDesignTypes.SECONDARY:
        return `
        background: ${theme.colors.semantic.container.white};
        color: ${theme.colors.semantic.text.strong};
        border: 1px solid ${theme.colors.semantic.outline.default};
      `;

      case buttonDesignTypes.DANGER:
        return `
        background: ${theme.colors.error[50]};
        color: ${theme.colors.semantic.text.weak};
        border: 1px solid ${theme.colors.error[50]};
        padding: 6px 9px;
      `;

      case buttonDesignTypes.ACCENT:
        return `
        background: ${theme.colors.accent[50]};
        color: ${theme.colors.semantic.text.weak};
        border: 1px solid ${theme.colors.accent[50]};
        padding: 6px 9px;
      `;

      default:
        return `
        background: ${theme.colors.semantic.container.gray};
        color: ${theme.colors.semantic.text.weak};
        border: 1px solid ${theme.colors.semantic.container.gray};
      `;
    }
  }};

  &:hover {
    ${({ $buttonDesignType, theme }) => {
      switch ($buttonDesignType) {
        case buttonDesignTypes.PRIMARY:
          return `
        background: ${theme.colors.semantic.accent.hover};
        color: ${theme.colors.semantic.accent.onAccent};
        border: 1px solid ${theme.colors.semantic.accent.hover};
      `;

        case buttonDesignTypes.SECONDARY:
          return `
        background: ${theme.colors.accent[50]};
        color: ${theme.colors.accent[500]};
        border: 1px solid ${theme.colors.accent[500]};
      `;

        case buttonDesignTypes.DANGER:
          return `
        background: ${theme.colors.error[500]};
        color: ${theme.colors.semantic.accent.onAccent};
        border: 1px solid ${theme.colors.error[500]};
      `;

        case buttonDesignTypes.ACCENT:
          return `
        background: ${theme.colors.accent[500]};
        color: ${theme.colors.semantic.accent.onAccent};
        border: 1px solid ${theme.colors.accent[500]};
      `;

        default:
          return `
        background: ${theme.colors.semantic.container.grayHover};
        color: ${theme.colors.semantic.text.weak};
        border: 1px solid ${theme.colors.semantic.container.grayHover};
      `;
      }
    }};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.semantic.accent.disabled};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    color: ${({ theme }) => theme.colors.semantic.text.disabled};
    opacity: 0.4;
  }
`;
